var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ButtonContainer = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: pointer;\n    text-decoration: none;\n    padding: ", ";\n    outline: none;\n    border-radius: ", ";\n    transition-duration: 0.2s;\n    ", ";\n"], ["\n    display: inline-block;\n    cursor: pointer;\n    text-decoration: none;\n    padding: ", ";\n    outline: none;\n    border-radius: ", ";\n    transition-duration: 0.2s;\n    ", ";\n"])), function (_a) {
    var padding = _a.padding, theme = _a.theme;
    return padding || theme.spacing.small + " " + theme.spacing.medium;
}, function (_a) {
    var borderRadius = _a.borderRadius, theme = _a.theme;
    return borderRadius || theme.typography.border.radius.small;
}, function (_a) {
    var width = _a.width;
    return (width !== null && width !== undefined ? "width: " + width : '');
});
var templateObject_1;
